"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_thumbs__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "89cedbfd-f17c-4849-ad1b-d58c8c4d058a",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "like"), /*#__PURE__*/React.createElement("g", {
    id: "2e4b3d56-3597-4653-9b78-f6052da43069",
    "data-name": "Like_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.21,172H145.58c11.53,0,21-8.94,15.87-21.45C173.2,137,167,126.75,167,126.75s11.11-12.06.32-23.8c2.79-7.85,4.4-14.79-5.84-21.73S126.9,81,118,82.13C106.12,78.33,141.58,21,103.84,20c-.16.41-4.4-1-3.2,13.88,0,15.53-29.32,50.12-38.91,63.58",
    transform: "translate(-16 -16)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,172H40a20,20,0,0,1-20-20V112A20,20,0,0,1,40,92h8a20,20,0,0,1,20,20Z",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _default = ic_thumbs__dark;
exports.default = _default;